// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthorLink__root--3TOm3","bounce":"AuthorLink__bounce--uMB5C"};